import { render } from "./LandingPokemons.vue?vue&type=template&id=08ce4577"
import script from "./LandingPokemons.vue?vue&type=script&lang=js"
export * from "./LandingPokemons.vue?vue&type=script&lang=js"
script.render = render

export default script